import {useEffect, useState} from 'react'
import {useSelector} from 'react-redux'

import {BookingStatus} from '@vio/core/src/api-types/bovio/response/booking'
import {Bookings} from '@vio/core/src/api-types/bovio/response/bookings'
import {selectIsAuthenticated} from '@vio/core/src/auth/modules/selectors'
import {getUserSessionService} from '@vio/core/src/auth/services'
import {useGetBookingsQuery} from '@vio/core/src/booking/services/bookApi'
import {BookingsFiltersValues} from '@vio/core/src/booking/types/BookingsFilterValues'
import {getBovioApiKey} from '@vio/core/src/experiments/modules/selectors'
import {getLocalDeviceDate} from '@vio/core/src/utils/date'
import {logger} from '@vio/core/src/utils/logging/logger'

const EMPTY_BOOKINGS: Bookings[] = []

export const useGetBookings = () => {
  const [idToken, setIdToken] = useState<string>()
  const appVersion = process.env.NEXT_PUBLIC_APP_VERSION

  const boVioEndpoint = process.env.NEXT_PUBLIC_BOVIO_ENDPOINT
  const profileKey = useSelector(getBovioApiKey)
  const isAuthenticated = useSelector(selectIsAuthenticated)

  const TODAY = getLocalDeviceDate()

  const params = {
    statuses: [BookingStatus.Confirmed, BookingStatus.ChargeLaterConfirmed],
    check_out_after: TODAY,
    sort: ['+check_in', '+inserted_at']
  }

  const result = useGetBookingsQuery(
    {
      profileKey,
      link: `${boVioEndpoint}bookings/`,
      params,
      filter: BookingsFiltersValues.Completed,
      authToken: idToken!,
      clientUserAgent: `home/${appVersion}`
    },
    {
      skip: Boolean(!idToken),
      selectFromResult: result => ({
        ...result,
        bookings: result.data ?? EMPTY_BOOKINGS
      })
    }
  )

  useEffect(() => {
    if (!idToken && isAuthenticated) {
      getUserSessionService()
        .then(resp => setIdToken(resp?.idToken.toString()))
        .catch(() =>
          logger.error(
            'Cognito: Error fetching user session on bookings retrieval'
          )
        )
    }
  }, [idToken, isAuthenticated])

  return result
}
